import { Phone } from "lucide-react";
import { useCity } from "@/context/LocationContext";

const PHONE = "06 49 50 18 43";
const TEL_HREF = "tel:+33649501843";

const EmergencyBanner = () => {
    const { city, postal } = useCity();
    const zone = city ? `${city}${postal ? " " + postal : ""} · Dépannage Express` : "Dépannage Express";
    return (
        <a
            href={TEL_HREF}
            data-testid="emergency-banner"
            className="block w-full bg-[#E63946] text-white hover:bg-[#D62828] transition-colors duration-200"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-center gap-3 text-sm font-medium">
                <span className="relative flex h-2 w-2">
                    <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-75 pulse-dot"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                </span>
                <span className="hidden sm:inline uppercase tracking-[0.18em] text-xs font-semibold">
                    Urgence Serrurerie 24/7 — {zone}
                </span>
                <span className="sm:hidden uppercase tracking-[0.15em] text-xs font-semibold">
                    Urgence 24/7
                </span>
                <span className="h-3 w-px bg-white/40 mx-1" />
                <Phone className="h-4 w-4" strokeWidth={2.4} />
                <span className="font-display font-bold tracking-tight text-sm sm:text-base">{PHONE}</span>
            </div>
        </a>
    );
};

export default EmergencyBanner;
